import { FC, PropsWithChildren } from 'react';

import { Loader, LoaderProps } from '@eon-home/react-library';

export interface WithLoaderProps {
    loading: boolean;
    className?: string;
    loaderProps?: LoaderProps;
}

export const WithLoader: FC<Readonly<PropsWithChildren<WithLoaderProps>>> = ({
    loading,
    children,
    className,
    loaderProps,
}) => {
    if (!loading) {
        // eslint-disable-next-line
        return <>{children}</>;
    }

    return className ? (
        <div className={className}>
            <Loader {...loaderProps} />
        </div>
    ) : (
        <Loader {...loaderProps} />
    );
};
